import { render, staticRenderFns } from "./ExamEditable.vue?vue&type=template&id=09ee004f&scoped=true&"
import script from "./ExamEditable.vue?vue&type=script&lang=js&"
export * from "./ExamEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee004f",
  null
  
)

export default component.exports